import { useLocation } from 'react-router-dom';
import Title from 'components/ui-components/Title';
import Card from 'components/ui-components/Card';
import SubmissionFail from 'components/mycef/Register/RegisterForm/SubmissionViews/SubmissionFail';
import { EmailIcon, PhoneIcon } from 'assets/icons';
import MetaHelmet from 'helpers/MetaHelmet';
import { branchTermSingular } from 'utils/terminology';

const IdentityVerificationFail = () => {
  const location = useLocation();
  const branchData = location.state;

  if (!branchData) return <SubmissionFail />;

  const { name, email, contact } = branchData;

  return (
    <>
      <MetaHelmet />
      <div className="margin-center l-width-60">
        <Title icon="error" title="Registration Unsuccessful" />

        <div className="mt-10 m-mt-20 ta-c fl ai-c fl-col">
          <p className="fs-18 lh-1-4 fw-400 tc-secondary">
            Sorry, we are unable to complete your application. Your details have
            been sent to our Account Creation team. If you would like more
            information, please contact your local {branchTermSingular} using
            the details below:
          </p>

          <Card className="mt-20 ta-l small-width" variant="small">
            <h2 className="ff-body fs-20 lh-1 tc-main mb-8">{name}</h2>

            <p className="fs-16 fw-400 fl ai-c tc-secondary mtb-16">
              <EmailIcon width={18} height={18} fillColor="#d02239" />{' '}
              <a href={`mailto:${email}`} className="ml-8">
                {email}
              </a>
            </p>
            <p className="fs-16 fw-400 fl ai-c tc-secondary">
              <PhoneIcon width={18} height={18} fillColor="#d02239" />{' '}
              <span className="ml-8">{contact}</span>
            </p>
          </Card>

          <a className="cef-btn cef-btn--feature cef-btn--grey mt-20" href="/">
            Back to Home
          </a>
        </div>
      </div>
    </>
  );
};

export default IdentityVerificationFail;
